export default __webpack_public_path__ + "static/media/special.26ab5e6c.png";